<template>
  <main v-if="!isSecretKeyValid" role="main">
    <div v-if="isCheckingSecretKey" class="py-5 text-center"><b-spinner/></div>
    <div v-else-if="secretKeyErrorMsg" class="py-5 text-center text-danger">{{ secretKeyErrorMsg }}</div>
  </main>
  <main v-else role="main" class="d-flex flex-column align-items-center justify-content-center py-4">
    <b-row v-if="!successMessage" no-gutters class="box border rounded">
      <b-col cols="6" class="left-item">
        <div class="text-center px-3" style="margin: 4rem 0;">
          <h4>{{ $t("welcomeMsg") }}</h4>
          <p>{{ $t("welcomeMsgSubtitle") }}</p>
        </div>
        <div class="text-center px-5">
          <img class="w-100" :src="`${publicPath}images/account_info.eabb9317.png`" :alt="$t('welcomeMsg')">
        </div>
      </b-col>
      <b-col cols="6" class="p-4">
        <b-form class="mb-3" @keydown="formKeyDown" @submit.prevent="onSubmit">
          <div v-if="isLoading" class="py-5 text-center"><b-spinner/></div>
          <template v-else-if="passwordPolicy">
            <b-form-group>
              <template v-slot:label>{{ $t("fullName") }} <span class="text-danger">*</span></template>
              <b-input-group>
                <b-form-input type="text" class="custom-validity-fix" name="name" required v-model="fullName"
                              @invalid="$event.target.setCustomValidity($t('cannotLeaveFieldBlank'))"
                              @input.native="$event.target.setCustomValidity('')" />
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <template v-slot:label>{{ $t("phoneNumber") }} <span class="text-danger">*</span></template>
              <b-input-group>
                <b-form-input type="tel" name="phone" class="custom-validity-fix" required v-model="phone"
                              :pattern="phonePattern" maxlength="50"
                              @invalid="$event.target.setCustomValidity($t('invalidPhoneFormat'))"
                              @input.native="$event.target.setCustomValidity('')" />
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <template v-slot:label>{{ $t("address") }}</template>
              <b-input-group>
                <b-form-textarea name="address" v-model="address" />
              </b-input-group>
            </b-form-group>
            <b-form-group >
              <template v-slot:label>   {{ $t(isVNPT ?  "nameUnit":"companyName" ) }}</template>
              <b-input-group>
                <b-form-input type="text" name="companyName" v-model="companyName" />
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <template v-slot:label>{{ $t("province") }} <span  class="text-danger">*</span></template>
<!--              <b-form-select text-field="name" value-field="name" :options="provinceOptions" :required="isVNPT" v-model="province"></b-form-select>-->
              <v-select label="name" class="vs-normalizer"
                        :options="provinceOptions" :reduce="p => p.name"
                        :filterBy="provinceSelectSearch"
                        v-model="province">
                <template v-slot:search="{attributes, events}">
                  <input id="input-province" v-bind="attributes" v-on="events" v-model="province" required
                         class="form-control"  minlength="2" maxlength="100"/>
                </template>
              </v-select>
            </b-form-group>


            <b-form-group v-show="isVNPT">
              <!-- <template v-slot:label>{{ $t("corporation") }} <span v-if="isVNPT" class="text-danger">*</span></template> -->
              <!-- <b-form-radio-group class="mb-2" name="corporationType" :options="corporationTypeOptions" v-model="corporationType" @change="onCorporationTypeChange" />
              <select name="corporation" :required="isVNPT" v-model="corporation" class="custom-select">
                <option value="" disabled selected>Vui lòng chọn</option>
                <option v-for="option in corporationOptions" :key="option" :value="option">{{ option }}</option>
              </select> -->
              <template v-slot:label>{{ $t("invnpt") }} <span v-if="isVNPT" class="text-danger">*</span></template>
              <b-form-select :required="isVNPT"  v-model="corporation" :options="corporationOptionsIn" >
              <template #first>
              <b-form-select-option :value="null" disabled>{{ $t("pleaseChoose") }}</b-form-select-option>
              </template>
              </b-form-select>
            </b-form-group>

              <b-form-group v-show="!isVNPT">
              <template v-slot:label>{{ $t("customerType") }} <span v-if="!isVNPT" class="text-danger">*</span></template>
              <b-form-select :required="!isVNPT" v-model="corporation" :options="corporationOptionsOut" >
              <template #first>
              <b-form-select-option :value="null" disabled>{{ $t("pleaseChoose") }}</b-form-select-option>
              </template>
            </b-form-select>


            </b-form-group>


            <b-form-group :description="passwordPolicy.passwordDescription">
              <template v-slot:label>{{ $t("password") }} <span class="text-danger">*</span></template>
              <b-input-group>
                <b-form-input type="password" name="password" autocomplete="new-password" required v-model="newPassword"
                              :minlength="passwordPolicy.minPasswordLength"
                              :maxlength="passwordPolicy.maxPasswordLength"
                              :pattern="passwordPolicy.passwordPattern"
                              @invalid.native="$event.target.setCustomValidity(passwordPolicy.passwordValidationFailedMessage)"
                              @input.native="$event.target.setCustomValidity('')"/>
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <template v-slot:label>{{ $t("confirmPassword") }} <span class="text-danger">*</span></template>
              <b-input-group>
                <b-form-input type="password" name="confirmPassword" autocomplete="new-password" required v-model="confirmPassword" />
              </b-input-group>
            </b-form-group>
            <p v-if="formErrorMsg" class="text-danger">{{ $t(formErrorMsg) }}</p>
            <b-button type="submit" variant="primary" block :disabled="isSubmitting" @click="beforeSubmit">
              {{ $t("register") }}
            </b-button>
          </template>
        </b-form>
      </b-col>
    </b-row>
    <div v-else class="box box-success text-center border rounded p-5">
      <h2 class="my-5">{{ $t("signupSuccessful") }}</h2>
      <p class="my-5" style="font-size: 20px; white-space: pre-wrap;">{{ successMessage }}</p>
      <b-button variant="primary" to="/login">{{ $t("login") }}</b-button>
    </div>
<!--    <b-button variant="link" @click="successMessage = successMessage? '' : $t('signupSuccessfulSubtitle')">Toggle</b-button>-->
  </main>
</template>

<style lang="scss" scoped>
.box {
  flex-shrink: 0;
  width: 880px;
  min-height: 700px;
  box-shadow: 0px 4px 40px rgb(0 0 0 / 15%);
}
.left-item {
  background-color: #dae0e9;
  color: #595959;
}
</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as passwordPolicyService from "@/service/passwordPolicyService";
  import * as userService from "@/service/userService";
  import * as util from "@/service/util";
  import provinces from "@/provinces.json";

  @Component
  export default class Activation extends BaseComponent {

    secretKey = "";
    isCheckingSecretKey = true;
    isSecretKeyValid = false;
    secretKeyErrorMsg = "";

    isLoading = true;
    passwordPolicy = null;

    isVNPT = false;

    fullName = "";
    phone = "";
    address = "";
    companyName = "";

    provinceOptions = provinces;
    province = "";

    // corporationTypeOptions = [
    //   { value: "in", text: "Trong VNPT" },
    //   { value: "out", text: "Ngoài VNPT" },
    // ];
    // corporationType = "in";

    // get corporationOptions() {
    //   if (this.corporationType === "in") {
    //     return [ "Vinaphone", "Media", "NET", "VT-TTP", "Cơ quan TĐ", "IT", "Khác" ];
    //   } else if (this.corporationType === "out") {
    //     return [ "Doanh nghiệp", "Cơ quan nhà nước", "Khác" ];
    //   }
    // }
    // corporation = "";

    corporation = null;

    corporationOptionsIn = [
      { value: "vinaphone", text:  this.$t("vinaphone").toString() },
      { value: "media", text:  this.$t("media").toString() },
      { value: "net", text: this.$t("net").toString() },
      { value: "vt_ttp", text:  this.$t("vt_ttp").toString() },
      { value: "tdagency", text:  this.$t("tdagency").toString() },
      { value:"it", text:  this.$t("it").toString() },
      { value: "other", text:  this.$t("other").toString() },
    ];
    corporationOptionsOut = [
      { value: "personal", text: this.$t("personal").toString() },
      { value: "business", text: this.$t("business").toString() },
      { value: "organ", text:  this.$t("organ").toString() },
      { value: "other", text:  this.$t("other").toString() },
    ];

    newPassword = "";
    confirmPassword = "";

    formErrorMsg = "";
    isSubmitting = false;
    successMessage = "";

    async mounted() {
      this.secretKey = this.$route.query.code as string;

      if (!this.secretKey) {
        this.isCheckingSecretKey = this.isSecretKeyValid = false;
        this.secretKeyErrorMsg = "invalidSecretKey";
        return;
      }

      try {
        const verifyResult = await userService.verifyActivationCode(this.secretKey);
        this.isVNPT = !!verifyResult.isVNPT;

        this.isSecretKeyValid = true;
        this.fetchPasswordPolicy();

      } catch (e) {
        this.isSecretKeyValid = false;
        this.secretKeyErrorMsg = e.response?.data?.code || e.code;

      } finally {
        this.isCheckingSecretKey = false;
      }
    }

    async fetchPasswordPolicy() {
      try {
        this.isLoading = true;
        this.passwordPolicy = await passwordPolicyService.get();

      } catch (e) {
        this.toastError(e);

      } finally {
        this.isLoading = false;
      }
    }

    provinceSelectSearch(option, label, searchText) {
      searchText = util.sanitizeSearchText(searchText.toLowerCase());
      return util.sanitizeSearchText(label).toLowerCase().includes(searchText);
    }

    onCorporationTypeChange() {
      this.corporation = "";
    }

    formKeyDown(event: KeyboardEvent) {
      return event.key !== 'Enter';
    }

    beforeSubmit() {
      this.fullName = this.fullName.trim();
      this.phone = this.phone.trim();
      this.address = this.address.trim();
      this.companyName = this.companyName.trim();
      util.clearCustomValidity();
    }

    async onSubmit() {
      this.formErrorMsg = null;

      if (this.newPassword !== this.confirmPassword) {
        this.formErrorMsg = "passwordsNotMatch";
        return;
      }

      try {
        this.isSubmitting = true;

      let data:any={

          secretKey: this.secretKey,
          name: this.fullName,
          phone: this.phone,
          address: this.address,
          companyName: this.companyName,
          province: this.province,
          password: this.newPassword,

        }
        if(this.isVNPT){
        data.customerType= "invnpt",
        data.corporations= this.corporation
      }else{
        data.customerType= "outside",
        data.idType= this.corporation
      }
        const activateAccountRet = await userService.activateAccount(data);


        this.successMessage = activateAccountRet?.message || this.$t("signupSuccessfulSubtitle").toString();

      } catch (e) {
        this.formErrorMsg = e.response?.data?.code || e.code;

      } finally {
        this.isSubmitting = false;
      }
    }

  }
</script>
